import { observer } from 'mobx-react-lite';
import EventDetails from '../../../ClinicalEvents/EventDetails';
import EventDetailsHeader from './EventDetailsHeader';

const EventDetailsContent = ({
  onChange,
  uuid,
}: {
  onChange: (uuid: string) => void;
  uuid: string;
}) => {
  return (
    <>
      <EventDetailsHeader uuid={uuid} onChange={onChange} />
      <EventDetails uuid={uuid} />
    </>
  );
};

export default observer(EventDetailsContent);
